export default __webpack_public_path__ + "static/media/maikolSinFondo2.c6f14554.png";